<template>
  <component :is="currentView" :active="active"></component>
</template>

<script>
import isNil from 'lodash/isNil';
import { mapGetters } from 'vuex';
import WHostClusterConfigView from './hostcluster';
import WHostConfigView from './host';
import WVmConfigView from './vm';
import WStorageClusterConfigView from './storagecluster';
import WStorageConfigView from './storage';

export default {
  name: 'WConfigVirtualNode',
  components: {
    WHostClusterConfigView,
    WHostConfigView,
    WVmConfigView,
    WStorageClusterConfigView,
    WStorageConfigView,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(node) {
        if (!this.active) {
          return;
        }
        if (!isNil(node)) {
          this.changeView();
        }
      },
    },
    active: {
      handler(active) {
        if (active) {
          this.changeView();
        }
      },
    },
  },
  methods: {
    changeView() {
      if (this.selectedNode.obj.objtypeId === 'VCL') {
        this.currentView = WHostClusterConfigView.name;
      } else if (this.selectedNode.obj.objtypeId === 'VHO') {
        this.currentView = WHostConfigView.name;
      } else if (this.selectedNode.obj.objtypeId === 'VVM') {
        this.currentView = WVmConfigView.name;
      } else if (this.selectedNode.obj.objtypeId === 'VDSC') {
        this.currentView = WStorageClusterConfigView.name;
      } else if (this.selectedNode.obj.objtypeId === 'VDS') {
        this.currentView = WStorageConfigView.name;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/virtual/index.vue